import { render, staticRenderFns } from "./S_order_fulfil.vue?vue&type=template&id=627e766c&scoped=true"
import script from "./S_order_fulfil.vue?vue&type=script&lang=js"
export * from "./S_order_fulfil.vue?vue&type=script&lang=js"
import style0 from "./S_order_fulfil.vue?vue&type=style&index=0&id=627e766c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627e766c",
  null
  
)

export default component.exports